import React, { useEffect } from "react";
import { GetDeliveryHistory } from "../../../APIServices/SalesService/DeliveryService/deliveryHistory";
import HistoryPage from "./historyPage";
const DeliveryHistory = () => {
  return (
    <HistoryPage
      fetchHistoryThunk={GetDeliveryHistory}
      historySelector={(state) => state.Delivery.DeliveryHistory}
      loadingSelector={(state) => state.Delivery.loading}
      errorSelector={(state) => state.Delivery.error}
      type="delivery"
      tabLabels={{loading:"CURRENTLY LOADING", open: "DISPATCHED", closed: "COMPLETED"}}
    />
  );
};

export default DeliveryHistory;
